// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark .followed-empty{background-color:#333;border-color:#4d4d4d}html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark .followed-section-title{color:rgba(255,255,255,0.9)}html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark .followed-slider-wrapper{background:#666}\n", ""]);
// Exports
module.exports = exports;
